var map = {
	"./additionalInfoIcon.svg": 715,
	"./arrowLeftIcon.svg": 716,
	"./arrowMediumTop.svg": 717,
	"./arrowRightIcon.svg": 718,
	"./arrowRightIconSharp.svg": 719,
	"./arrowRightSmallIcon.svg": 720,
	"./arrowScalableIcon.svg": 721,
	"./arrowSelect2.svg": 722,
	"./arrowSelectIcon.svg": 723,
	"./benefit1.svg": 724,
	"./benefit2.svg": 725,
	"./benefit3.svg": 726,
	"./cardsIcon.svg": 727,
	"./crossIcon.svg": 728,
	"./crossIcon2.svg": 729,
	"./crossIcon3.svg": 730,
	"./crossIconSmall.svg": 731,
	"./crossSmallIcon.svg": 732,
	"./defaultCategoryIcon.svg": 733,
	"./depNumberIcon.svg": 734,
	"./elfCentralIcon.svg": 735,
	"./equalitySign.svg": 736,
	"./errorIcon.svg": 737,
	"./eyeClosedIcon.svg": 738,
	"./eyeOpenIcon.svg": 739,
	"./favoritesIcon.svg": 740,
	"./favoritesLabelIcon.svg": 741,
	"./filterDivider.svg": 742,
	"./filterIcon.svg": 743,
	"./frequencyIcon.svg": 744,
	"./fsAmountIcon.svg": 745,
	"./fullScreenIcon.svg": 746,
	"./gameIcon.svg": 747,
	"./hamburgerIcon.svg": 748,
	"./infoIcon.svg": 749,
	"./infoSymbol.svg": 750,
	"./levelBackground.svg": 751,
	"./levelBackgroundNew.svg": 752,
	"./lockIcon.svg": 753,
	"./maxBonusAmountIcon.svg": 754,
	"./maxWinFsIcon.svg": 755,
	"./menu/fortuneIcon.svg": 470,
	"./menu/fortuneIconL.svg": 471,
	"./menu/helpdeskIcon.svg": 472,
	"./menu/helpdeskIconL.svg": 473,
	"./menu/homeIcon.svg": 474,
	"./menu/homeIconLarge.svg": 475,
	"./menu/jackpotIcon.svg": 476,
	"./menu/logo.svg": 477,
	"./menu/logoSmall.svg": 478,
	"./menu/loyaltyIcon.svg": 479,
	"./menu/mobileAppIcon.svg": 480,
	"./menu/profileIcon.svg": 481,
	"./menu/questIcon.svg": 482,
	"./menu/rewardLineupIcon.svg": 483,
	"./menu/searchIcon.svg": 484,
	"./menu/searchIconLarge.svg": 485,
	"./menu/signOutIcon.svg": 486,
	"./menu/star.svg": 487,
	"./menu/tournamentIcon.svg": 488,
	"./menu/tournamentLargeIcon.svg": 489,
	"./menu/vipIcon.svg": 490,
	"./menu/wheelIcon.svg": 491,
	"./menu/wheelIconL.svg": 492,
	"./menu/wheelIconMobile.svg": 493,
	"./menuIcon.svg": 756,
	"./minDepIcon.svg": 757,
	"./noTournamentIcon.svg": 758,
	"./numbers/number-1.svg": 494,
	"./numbers/number-2.svg": 495,
	"./numbers/number-3.svg": 496,
	"./numbers/number-4.svg": 497,
	"./numbers/number-5.svg": 498,
	"./numbers/number-6.svg": 499,
	"./numbers/number-7.svg": 500,
	"./numbers/number-8.svg": 501,
	"./numbers/number-9.svg": 502,
	"./numbers/number-shine-1.svg": 503,
	"./numbers/number-shine-2.svg": 504,
	"./numbers/number-shine-3.svg": 505,
	"./numbers/number-shine-4.svg": 506,
	"./numbers/number-shine-5.svg": 507,
	"./numbers/number-shine-6.svg": 508,
	"./numbers/number-shine-7.svg": 509,
	"./numbers/number-shine-8.svg": 510,
	"./numbers/number-shine-9.svg": 511,
	"./playIcon.svg": 759,
	"./polygon.svg": 760,
	"./preloaderDotsAnimation.svg": 761,
	"./preloaderSpinnerAnimation.svg": 762,
	"./promoIcon.svg": 763,
	"./recentIcon.svg": 764,
	"./search2Icon.svg": 765,
	"./search3Icon.svg": 766,
	"./smallInfoSymbol.svg": 767,
	"./successIcon.svg": 768,
	"./supportIcon.svg": 769,
	"./tag1Icon.svg": 770,
	"./tag2Icon.svg": 771,
	"./tag3Icon.svg": 772,
	"./tag4Icon.svg": 773,
	"./tickIcon.svg": 774,
	"./unverified.svg": 775,
	"./verified.svg": 776,
	"./wagerIcon.svg": 777,
	"./wagerTimeIcon.svg": 778,
	"./warningIcon.svg": 779
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 714;